import { apiSlice } from '@/store/api/apiSlice';

export interface GeneralPredictionResponse {
  status: 'PENDING' | 'SUCCESS' | 'FAILED';
  prediction: string;
  videoId?: string | null;
  id?: string;
}

export interface GeneralPredictionRequest {
  userId: string;
}

export interface SyncPredictionRequest {
  predictionId: string;
  language: string;
  content?: Record<string, any>;
  videoUrl?: string;
  audioUrl?: string;
}

export interface SyncPredictionResponse {
  status?: number;
  message: string | string[];
  error?: string;
  statusCode?: number;
}

export const generalPredictionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGeneralPrediction: builder.query<GeneralPredictionResponse, GeneralPredictionRequest>({
      query: ({ userId }) => ({
        url: '/predictions/general',
        method: 'GET',
        params: {
          userId,
        },
      }),
    }),
    syncPrediction: builder.mutation<SyncPredictionResponse, SyncPredictionRequest>({
      query: (data) => ({
        url: '/predictions/sync-prediction',
        method: 'POST',
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetGeneralPredictionQuery, useSyncPredictionMutation } = generalPredictionApi;
